//
//
//      USE NUMBRO INSTEAD. thx
//
//

type Type = Intl.NumberFormatPartTypes | 'percent';
interface Options {
  type?: Type;
  minDecimalPlaces?: number;
  maxDecimalPlaces?: number;
  includeThousandsSeparator?: boolean;
}

export const formatNumberLegacy: (value: number, options: Options) => string = (
  value,
  {
    type = 'decimal',
    minDecimalPlaces = 0,
    maxDecimalPlaces = 0,
    includeThousandsSeparator = true,
  } = {},
) =>
  Math.abs(value) <= 999999999
    ? new Intl.NumberFormat('en-US', {
        style: type,
        currency: 'USD',
        minimumFractionDigits: minDecimalPlaces,
        maximumFractionDigits: maxDecimalPlaces,
        useGrouping: includeThousandsSeparator,
      }).format(value)
    : `${type === 'currency' ? '$' : ''}${value.toExponential(2)}${type === 'percent' ? '%' : ''}`;
